import { TourStep } from '@/hooks/useTour';

export interface TaskGuide {
  id: string;
  steps: TourStep[];
}

export const taskGuides: Record<string, TaskGuide> = {
  profile: {
    id: 'profile',
    steps: [
      {
        id: 'profile-bio',
        targetId: 'profile-bio-field',
        title: 'Add your bio here',
        position: 'top'
      }
    ]
  },
  rsvp: {
    id: 'rsvp',
    steps: [
      {
        id: 'event-card',
        targetId: 'event-card-first',
        title: 'Tap an event to see details',
        position: 'bottom'
      }
    ]
  },
  buddy: {
    id: 'buddy',
    steps: [
      {
        id: 'buddy-toggle',
        targetId: 'buddy-toggle',
        title: 'Toggle this ON to find a buddy',
        position: 'top'
      }
    ]
  },
  herd: {
    id: 'herd',
    steps: [
      {
        id: 'herd-card',
        targetId: 'herd-card-first',
        title: 'Tap a herd to join',
        position: 'bottom'
      }
    ]
  },
  friend: {
    id: 'friend',
    steps: [
      {
        id: 'friend-find',
        targetId: 'friend-find-button',
        title: 'Tap here to find friends',
        position: 'bottom'
      }
    ]
  },
  attend: {
    id: 'attend',
    steps: [
      {
        id: 'attend-info',
        type: 'fullscreen',
        title: 'Check in when you arrive at the event',
        description: 'Look for the check-in button on the event page'
      }
    ]
  }
};
